import {
  refactorHomeCashObj,
  refactorBookingObj,
  refactorHotelsObj,
  generateCSV_bookings,
} from "../../utils/misc";
import {
  HOME_TYPE,
  HOME_CASH_BOOKING_TYPES,
  BOOKING_TYPES,
  HOTEL_TYPES,
} from "../types";

const initialState = {
  // Homes
  homes: [],
  totalCount: 0,
  approvedCount: 0,
  pendingCount: 0,
  currentPage: 1,
  loading: false,
  home: null,

  // Reservations (cash bookings)
  reservations: [],
  reservation: null,

  // Bookings
  bookings: [],
  booking: null,
  home_csv: null,

  // Hotels
  hotels: [],
  totalHotelsCount: 0,
  approvedHotelsCount: 0,
  pendingHotelsCount: 0,
  hotel: null,
  tabValue: "details",
};

const homeReducers = (state = initialState, action) => {
  switch (action.type) {
    // ── Homes ────────────────────────────────────────────────────
    case HOME_TYPE.SET_LOADING:
      return { ...state, loading: action.payload };

    case HOME_TYPE.SET_HOME:
      return {
        ...state,
        homes: action.payload.results,
        totalCount: action.payload.count,
        approvedCount: action.payload.approved_count,
        pendingCount: action.payload.unapproved_count,
        currentPage: action.payload.page,
      };

    case HOME_TYPE.GET_HOME:
      return { ...state, home: action.payload };

    case HOME_TYPE.EDIT_HOME:
      return { ...state, successMessage: action.payload.message };

    // ── Cash Bookings (Reservations) ────────────────────────────
    case HOME_CASH_BOOKING_TYPES.FETCH_HOME_CASH_BOOKING_SUCCESS:
      return { ...state, reservations: refactorHomeCashObj(action.payload) };

    case HOME_CASH_BOOKING_TYPES.FETCH_HOME_CASH_BOOKING_BYID_SUCCESS:
      return { ...state, reservation: action.payload };

    // ── Home Bookings ───────────────────────────────────────────
    case BOOKING_TYPES.FETCH_HOME_BOOKINGS:
      return {
        ...state,
        bookings: refactorBookingObj(action.payload),
        home_csv: generateCSV_bookings(action.payload, "Home"),
      };

    case BOOKING_TYPES.FETCH_HOME_BOOKING_DETAILS:
      return { ...state, booking: action.payload };

    // ── Hotels ──────────────────────────────────────────────────
    case HOTEL_TYPES.SET_HOTELS_LOADING:
      return { ...state, hotelsLoading: action.payload };

    case HOTEL_TYPES.FETCH_HOTELS_SUCCESS:
      return {
        ...state,
        hotels: action.payload.results,
        totalHotelsCount: action.payload.count,
        approvedHotelsCount: action.payload.approved_count,
        pendingHotelsCount: action.payload.unapproved_count,
      };

    case HOTEL_TYPES.FETCH_HOTEL_SUCCESS:
      return { ...state, hotel: action.payload };

    case HOTEL_TYPES.TOGGLE_TABS:
      return { ...state, tabValue: action.payload };

    default:
      return state;
  }
};

export default homeReducers;
